import {
  FETCH_SUCCESS,
  FETCH_START,
  FETCH_FAILURE,
  TOGGLE
} from './actionTypes'

export const fetchSuccess = overlays => ({
  type: FETCH_SUCCESS,
  overlays
})

export const fetchStart = () => ({
  type: FETCH_START
})

export const fetchFail = error => ({
  type: FETCH_FAILURE,
  error
})

export const toggle = id => ({
  type: TOGGLE,
  id
})
